<template>
  <el-card
    shadow="never"
    class="customer-table"
  >
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="员工统计"
        name="employees"
      />
      <el-tab-pane
        label="客户统计"
        name="customer"
      />
    </el-tabs>

    <div class="text-tips">
      <el-popover
        placement="left"
        width="500"
        trigger="click"
      >
        <div class="statistics-shows">
          <div
            v-for="(item, index) in tipsList"
            :key="index"
          >
            <div class="title">
              {{ item.title }}
            </div>
            <div>{{ item.content }}</div>
          </div>
        </div>
        <div
          slot="reference"
          class="text-tips-btn"
        >
          <span>统计说明 </span>
          <i class="el-icon-question icon-question" />
        </div>
      </el-popover>
    </div>

    <div class="top-tips">
      <!-- 列表的搜索和操作 -->
      <div class="top-search">
        <el-input
          v-model="params.keywords"
          placeholder="员工姓名/员工号"
          class="input-m"
        />

        <el-button
          size="small"
          class="m-r-6"
          @click="storeVisible = true"
        >
          <span v-if="selectStoreData.length > 0">已选择 {{ selectStoreData.length }}家门店</span>
          <span v-else>添加门店以筛选</span>
        </el-button>

        <el-select
          v-model="params.employee_status"
          placeholder="请选择"
        >
          <el-option
            label="员工"
            value="1"
          />
          <el-option
            label="编外"
            value="2"
          />
        </el-select>

        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchList()"
        >
          搜索
        </el-button>
        <el-button
          type="primary"
          @click="exportDialogVisible = true"
        >
          导出
        </el-button>
      </div>
    </div>

    <el-tabs
      v-model="params.send_status"
      @tab-click="handleStatusClick"
    >
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.label"
        :name="item.name"
      />
    </el-tabs>

    <!-- 列表展示 -->
    <el-table
      v-loading="loading"
      :data="list"
    >
      <el-table-column
        v-for="item in menuList"
        :key="item.name"
        :prop="item.name"
        :label="item.label"
      />
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      class="content-padded content-right"
      style="margin-top: 16px"
      background
      :current-page="params.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="params.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total_count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <!-- 导出报表对话框 -->
    <SpExportList
      v-model="exportDialogVisible"
      :show-store-select="true"
      :files-type="fileType"
      show-employee-status
      :show-date-select="false"
      :add-params="{
        msg_id
      }"
    />

    <!-- 编辑门店对话框 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />
  </el-card>
</template>

<script>
import { employeesStatisticsList, customerStatisticsList } from '../../../untils/menulist'
import { tipsList, employeesTabList, customerTabList } from './untils'

export default {
  data () {
    return {
      activeName: 'employees',
      list: [],
      loading: false,
      total_count: 0,
      storeVisible: false,
      selectStoreData: [],
      exportDialogVisible: false,
      params: {
        page: 1,
        page_size: 10,
        store_id: '',
        employee_status: '',
        keywords: '',
        send_status: 'wait'
      },
      menuList: employeesStatisticsList,
      tabList: employeesTabList,
      tipsList,
      fileType: 20, //导出文件类型 20 客户群发员工统计 21 客户群发客户统计
      msg_id: this.$route.params.id
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      const query = this.$route.params
      if (this.activeName === 'employees') {
        const data = await this.$api.membership.getStatisticSendSalesperson(query.id, this.params)
        if (data) {
          this.list = data.list
          this.total_count = data.total_count
        }
      } else {
        const data = await this.$api.membership.getStatisticSendMember(query.id, this.params)
        if (data) {
          this.list = data.list
          this.total_count = data.total_count
        }
      }
    },
    searchList () {
      this.params.page = 1
      this.getList()
    },
    resetSearch () {
      this.selectStoreData = []
      this.params.store_id = 0
      this.params.employee_status = ''
      this.params.keywords = ''
    },
    handleClick (tab) {
      this.activeName = tab.name
      if (tab.name === 'customer') {
        this.menuList = customerStatisticsList
        this.tabList = customerTabList
        this.fileType = 21
      } else {
        this.menuList = employeesStatisticsList
        this.tabList = employeesTabList
        this.fileType = 20
      }
      this.resetSearch()
      this.params.send_status = 'wait'
      this.params.page = 1
      this.getList()
    },
    handleStatusClick (tab) {
      this.params.send_status = tab.name
      this.params.page = 1
      this.getList()
    },

    // 选择店铺数据
    chooseStore (selectdata, storeids) {
      if (selectdata.length > 0) {
        this.selectStoreData = selectdata
        this.params.store_id = storeids
      } else {
        this.selectStoreData = []
        this.params.store_id = 0
      }
      this.storeVisible = false
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.m-r-6 {
  margin-right: 6px;
}
.top-tips {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-left {
    display: flex;
    .left-item {
      margin-right: 30px;
    }
  }
  .top-search {
    display: flex;
    > div {
      margin-right: 6px;
    }
  }
}
.customer-table {
  position: relative;
}
.text-tips {
  position: absolute;
  right: 20px;
  top: 20px;
  .text-tips-btn {
    cursor: pointer;
  }
  .icon-question {
    color: #9c9fa6;
  }
}
.statistics-shows {
  .title {
    color: #666;
    margin-top: 5px;
    margin-bottom: 2px;
    font-weight: 500;
    font-size: 15px;
  }
}
</style>
